export default "__VITE_PUBLIC_ASSET__6d5d90c8__"